import { render, staticRenderFns } from "./EstimationOtherCategorySelect.vue?vue&type=template&id=670bb35f&"
import script from "./EstimationOtherCategorySelect.vue?vue&type=script&lang=js&"
export * from "./EstimationOtherCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports